import { useRef, useState } from 'react'
import Slides from '../slides/Slides'
import { toast, Zoom } from 'react-toastify';
import { useAuthContext } from '../../context/authContext';

const SignIn = ({M}) => {
   const { login } = useAuthContext();
   const [formData,setFormData] = useState({
      cuit:             "",
      cuil:             "",
      apellidoNombre:   "",
      email:            ""
   });

   const iCuitRef           = useRef(null);
   const iCuilRef           = useRef(null);
   const iApellidoNombreRef = useRef(null);
   const iEmailRef          = useRef(null);

   const handleSubmit = (e) => {
      e.preventDefault();
      
      if (formData.cuit === null || formData.cuit === ""){
         toast.error("Ingrese el Nombre", { transition: Zoom });
         iCuitRef.current.focus();
         return;
      }
      if (formData.cuil === null || formData.cuil === ""){
         toast.error("Ingrese el Nombre", { transition: Zoom });
         iCuilRef.current.focus();
         return;
      }
      if (formData.apellidoNombre === null || formData.apellidoNombre === ""){
         toast.error("Ingrese el Nombre", { transition: Zoom });
         iApellidoNombreRef.current.focus();
         return;
      }
      if (formData.email === null || formData.email === ""){
         toast.error("Ingrese el Nombre", { transition: Zoom });
         iEmailRef.current.focus();
         return;
      }
      login(formData);
   }

   return (
      <>
         <Slides M={M} tipoSlides={"prevencion"}/>
         <div className="container animated fadeIn">
            <div className="section">
               <div className="section center">
                  <h5><strong>INGRESO</strong></h5>
               </div>
               <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="row">
                     <div className="card">
                        <div className="card-content">
                           <div className="row center">
                              <div className="input-field col s12 m6 l6 xl6">
                                 <input type="number" id="cuit" className="validate" 
                                    onChange={(e) => setFormData({
                                       ...formData, 
                                       cuit:e.target.value
                                    })}
                                    name="cuit" min="0" step="0" value={formData.cuit} required/>
                                 <label htmlFor="cuit">CUIT del Empleador</label>
                              </div>
                              <div className="input-field col s12 m6 l6 xl6">
                                 <input type="number" id="cuil" className="validate" 
                                    onChange={(e) => setFormData({
                                       ...formData, 
                                       cuil:e.target.value
                                    })}
                                    name="cuil" min="0" step="0" value={formData.cuil} required/>
                                 <label htmlFor="cuilEmpleado">CUIL del Empleado</label>
                              </div>
                           </div>
                           <div className="row center">
                              <div className="input-field col s12 m6 l6 xl6">
                                 <input type="text" id="apellidoNombre" 
                                 onChange={(e) => setFormData({
                                       ...formData, 
                                       apellidoNombre:e.target.value
                                    })}
                                    className="validate" name="apellidoNombre" value={formData.apellidoNombre} required/>
                                 <label htmlFor="apellidoNombre">Apellido y Nombre</label>
                              </div>
                              <div className="input-field col s12 m6 l6 xl6">
                                 <input type="email" id="email" 
                                    onChange={(e) => setFormData({
                                       ...formData, 
                                       email:e.target.value
                                    })}
                                    className="validate" name="email" value={formData.email} required/>
                                 <label htmlFor="email">E-mail</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="col s12 m12 center-align">
                                 <button className="btn waves-effect waves-light light-blue accent-3" type="submit" name="action">Continuar
                                    <i className="material-icons right">send</i>
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
            </div>
         </div>
      </>

   )
}

export default SignIn;